module.exports = __webpack_public_path__ + "media/gallery/photo01-9367a2bd.webp";